
import Fuse from 'fuse.js';
import { computed, ref, watch } from '@vue/composition-api';
import { Checkbox, InputText } from '05-ui-kit';
import type { FilterCheckbox } from '~/type/Filter';
interface Props {
  name: string;
  initialToggle: boolean;
  toggle: boolean;
  list: FilterCheckbox[];
  theme?: 'white' | 'yellow';
  value: {
    [key: string]: string;
  };
}
const __sfc_main = {};
__sfc_main.props = {
  name: {
    key: "name",
    required: true,
    type: String
  },
  initialToggle: {
    key: "initialToggle",
    required: false,
    type: Boolean,
    default: false
  },
  toggle: {
    key: "toggle",
    required: false,
    type: Boolean,
    default: false
  },
  list: {
    key: "list",
    required: true,
    type: Array
  },
  theme: {
    key: "theme",
    required: false,
    type: String,
    default: 'yellow'
  },
  value: {
    key: "value",
    required: true,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const innerToggle = ref(props.initialToggle);
  const activeCount = ref(0);
  const query = ref('');
  let fuse: any;
  const innerList = computed(() => {
    if (query.value) return getFuse().search(query.value)?.map((el: any) => el.item);else return props.list;
  });
  function change(data: FilterCheckbox) {
    emit('change', data);
  }
  function getFuse() {
    if (!fuse) return new Fuse(props.list, {
      includeScore: true,
      keys: ['name'],
      threshold: 0.4
    });else return fuse;
  }
  watch(() => props.value, val => {
    activeCount.value = props.list.reduce((acc, current: any) => {
      return acc + (val[current.property] ? 1 : 0);
    }, 0);
  }, {
    immediate: true
  });
  watch(() => props.list, val => {
    val.forEach((el: any) => {
      const inner = props.list.find(e => e.property === el.property);
      if (inner) inner.count = el.count;
    });
  }, {
    deep: true
  });
  return {
    innerToggle,
    activeCount,
    query,
    innerList,
    change
  };
};
__sfc_main.components = Object.assign({
  InputText,
  Checkbox
}, __sfc_main.components);
export default __sfc_main;
